import CONSTANTS from "../../assets/js/Constants"

const menu = {}
export default function (state = menu, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST:
         return { ...state, ...payload }

      case CONSTANTS.ACTION.MENU.UPDATE_FORM_LIST:
         return { ...state, ...payload }

      default:
         return { ...state }
   }
}
